import { useEffect } from 'react';
import { useDataFormPage } from '../../providers/DataFormPageProvider';
import { DataFormPage } from './DataFormPage';
import { NationalViewHighlights } from './NationalViewHighlights';
import { HeadCell } from '../Datatable/DatatableHeader';

const headCells: HeadCell<{
	cand_name: string;
	totalRaised: number;
	propSelf: number;
	propSmall: number;
	elec_state: string;
	chamber: string;
	District: string;
	party: string;
	status: string;
	cand_gender: string;
}>[] = [
	{
		id: 'cand_name',
		numeric: false,
		disablePadding: true,
		label: 'Candidate Name'
	},
	{
		id: 'totalRaised',
		numeric: true,
		numericFormat: 'currency',
		disablePadding: false,
		label: 'Total Raised',
		width: 150
	},
	{
		id: 'propSelf',
		numeric: true,
		numericFormat: 'percent',
		disablePadding: false,
		label: 'Proportion Self-Financed',
		width: 150
	},
	{
		id: 'propSmall',
		numeric: true,
		numericFormat: 'percent',
		disablePadding: false,
		label: 'Proportion Small Contributions',
		width: 150
	},
	{
		id: 'elec_state',
		numeric: false,
		disablePadding: false,
		label: 'State',
		sortable: false,
		width: 75
	},
	{
		id: 'chamber',
		numeric: false,
		disablePadding: false,
		label: 'Chamber'
	},
	// {
	// 	id: 'office_sought',
	// 	numeric: false,
	// 	disablePadding: false,
	// 	label: 'Office Sought'
	// },
	{
		id: 'District',
		numeric: true,
		disablePadding: false,
		label: 'District'
	},
	{
		id: 'party',
		numeric: false,
		disablePadding: false,
		label: 'Party'
	},
	// {
	// 	id: 'candRace',
	// 	numeric: false,
	// 	disablePadding: false,
	// 	label: 'Race'
	// },
	{
		id: 'status',
		numeric: false,
		disablePadding: false,
		label: 'Status'
	},
	{
		id: 'cand_gender',
		numeric: false,
		disablePadding: false,
		label: 'Gender',
		sortable: false
	}
];

interface NationalViewPageProps {}

export const NationalViewPage: React.FC<NationalViewPageProps> = () => {
	const { setPage } = useDataFormPage();
	useEffect(() => {
		setPage('national');
	});
	return (
		<DataFormPage
			chapter='national'
			headCells={headCells}
			idKey='cand_name'
			chapterHighlightViz={<NationalViewHighlights />}
		/>
	);
};
